<template>
  <div class="container page service-online-page">
    <van-nav-bar
      :title="$t('my.online_service')"
      class="nav-bar"
      :border="false"
    >
      <template #left>
        <van-icon name="arrow-left" @click="back()" />
      </template>
    </van-nav-bar>

    <div class="main-content">
      <div class="service-card">
        <div class="card-header">
          <div class="avatar-wrap">
            <img class="avatar" src="/img/mine/kefu_1.svg" alt="kefu">
          </div>
          <div class="service-info">
            <div class="name">{{ serviceName }}</div>
            <div class="status-dot">
              <span class="dot"></span>
              <span>Online</span>
            </div>
          </div>
          <button class="contact-btn" type="button" @click="toServicePage()">
            <van-icon name="chat-o" class="btn-icon" />
            {{ $t('my.contact') }}
          </button>
        </div>

        <div class="card-footer">
          <van-icon name="clock-o" class="time-icon" />
          <span class="time-text">{{ $t('my.service_time') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    serviceName() {
      const info = this.$store.getters.getBaseInfo || {}
      return info.name || this.$t('index.club_name')
    }
  },
  methods: {
    back() {
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.$router.replace({ path: '/Home' })
      }
    },
    toServicePage() {
      const service = this.$store.getters.getBaseInfo || {}
      if (service.iskefu == 1 && service.kefu) {
        window.location.href = service.kefu
        return
      }
      this.$router.push({ path: '/ServicePage' })
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";

.service-online-page {
  background: #f2f2f5;
}

.main-content {
  padding: 0.9375rem;
}

.service-card {
  background: #fff;
  border-radius: 0.9375rem;
  padding: 1.125rem 1rem 1rem;
  box-shadow: 0 0.125rem 0.75rem rgba(0, 0, 0, 0.08);
}

.card-header {
  display: flex;
  align-items: center;
  padding-bottom: 1rem;
  border-bottom: 1px dashed #eee;
}

.avatar-wrap {
  flex-shrink: 0;
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 50%;
  border: 0.125rem solid #d63f8c;
  padding: 0.125rem;
  margin-right: 0.75rem;
  box-sizing: border-box;
  background: #fff;
}

.avatar {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  display: block;
}

.service-info {
  flex: 1;
  min-width: 0;
  padding-right: 0.5rem;
}

.name {
  font-size: 1rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 0.375rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.status-dot {
  display: flex;
  align-items: center;
  font-size: 0.75rem;
  color: #999;
}

.dot {
  width: 0.5rem;
  height: 0.5rem;
  background-color: #07c160;
  border-radius: 50%;
  margin-right: 0.375rem;
  flex-shrink: 0;
}

.contact-btn {
  flex-shrink: 0;
  border: none;
  border-radius: 1.25rem;
  padding: 0.5rem 0.875rem;
  color: #fff;
  font-size: 0.875rem;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  background: linear-gradient(90deg, #f560cd 0%, #4f2b8a 100%);
  box-shadow: 0 0.125rem 0.375rem rgba(79, 43, 138, 0.25);
}

.btn-icon {
  font-size: 1rem;
  margin-right: 0.25rem;
}

.card-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 1rem;
  color: #999;
  font-size: 0.8125rem;
}

.time-icon {
  font-size: 1rem;
  margin-right: 0.375rem;
  color: #bbb;
}

.time-text {
  line-height: 1.4;
  text-align: center;
}
</style>
